import {HTTP, ERROR} from '@/http-common';
import Vue from 'vue';
const state = {
  loadingContent: false,
  user_profile: {
    name: 'C M'
  }
};

const mutations = {
  SET_USER_PROFILE(state, data) {
    state.user_profile = data;
  },
  SET_AVATAR(state, name) {
    state.user_profile.avatar = name;
  },
  RESET_USER(state) {
    state.user_profile = {
      name: 'C M'
    }
  }
};

const getters = {
  getUserProfile: state => state.user_profile,
  getUserLoading: state => state.loadingContent
};

const actions = {
  GET_USER_ACTION: ({commit}, payload) => {
    commit('RESET_USER');
    state.loadingContent = true;
    HTTP.get(`users/profile/edit`, {params: {user_id: payload.id, account_id: payload.account_id}})
      .then(response => {
        if (response.data.status == 'success') {
          commit('SET_USER_PROFILE', response.data.data);
          state.loadingContent = false;
        }
        ERROR(response);
      }).catch(err => {
      console.log(err);
    })
  },
  EDIT_USER_ACTION: ({commit}, context) => {
    context.start();
    HTTP.post(`users/profile/edit`, {
      job_title: state.user_profile.jobTitle,
      full_name: state.user_profile.fullName,
      phone_number: state.user_profile.primaryPhone,
      user_id: state.user_profile.id,
      email: state.user_profile.email
    })
      .then(response => {
        if (response.data.status == 'success') {
          Vue.prototype.$notify(response.data.data[0]);
        }
        if (response.data.status == 'error') {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
        ERROR(response);
        context.stop()
      }).catch(err => {
      console.log(err);
      context.stop();
    })
  },
  EDIT_USER_ACCESS_ACTION: ({commit}, payload) => {
    payload.context.start();
    HTTP.post(`users/access`, {
      user_id: state.user_profile.id,
      account_id: payload.account_id,
      access: state.user_profile.access
    })
      .then(response => {
        if (response.data.status == 'success') {
          Vue.prototype.$notify(response.data.data[0]);
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
        ERROR(response);
        payload.context.stop()
      }).catch(err => {
      console.log(err);
      payload.context.stop();
    })
  },
  EDIT_USER_PASSWORD_ACTION: ({commit}, context) => {
    context.start();
    HTTP.post(`users/profile/password`, {
      password: state.user_profile.currentPassword,
      new_password: state.user_profile.newPassword,
      user_id: state.user_profile.id
    })
      .then(response => {
        if(response.data.status == 'success') {
          Vue.prototype.$notify(response.data.data[0]);
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
        context.stop();
        ERROR(response);
      }).catch(err => {
      context.stop();
      console.log(err);
    })
  },
  EDIT_USER_AVATAR_ACTION: ({commit}, file) => {
    HTTP.post(`users/avatar`, {
      file,
      user_id: state.user_profile.id
    })
      .then(response => {
        ERROR(response);
        if(response.data.status == 'success') {
          commit('SET_AVATAR', response.data.data.name);
          Vue.prototype.$notify('Profile image updated.');
        }
      }).catch(err => {
      console.log(err);
    })
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/editUser.js